import { Ref } from 'vue'
import { CheckboxChildren } from './interface'
import { ValidateTiming } from '../../enums'

export const checkboxGroupProvision = Symbol('d-checkbox-group')

export interface CheckboxGroupProvision {
  modelValue: Ref<(string | number | boolean)[] | undefined>
  name: Ref<string>
  expand: Ref<boolean>
  validateTiming: Ref<ValidateTiming>
  validating: Ref<boolean>
  disabled: Ref<boolean>
  indicator: Ref<{ children: CheckboxChildren }>
  children: CheckboxChildren
}
